import React from 'react';
import EagleSpinner from './EagleSpinner';

const InitialLoader = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column', // Aby dodać tekst pod spodem
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#FFFFFF', // Kolor tła Twojej aplikacji
    }}>
      <EagleSpinner />
    </div>
  );
};

export default InitialLoader;